import React from "react";
import { FiMail, FiMapPin } from "react-icons/fi";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";

const footerGroups = [
  {
    title: "Customer Support",
    links: [
      ["Contact Us", "/contact"],
      ["Shipping Information", "/shipping"],
      ["Returns", "/returns"],
      ["FAQs", "/faqs"],
      ["Shopping Cart", "/cart"],
    ],
  },
  {
    title: "Company",
    links: [
      ["About Us", "/about"],
      ["Privacy Policy", "/privacy"],
      ["Terms & Conditions", "/terms"],
      ["Cookie Policy", "/cookies"],
    ],
  },
  {
    title: "Quick Bites",
    links: [
      ["Shop All", "/shop"],
      ["Gourmet Gifts", "/shop/gifts"],
      ["New Arrivals", "/shop?new=true"],
      ["Favorites", "/shop?wishlist=true"],
    ],
  },
];

const Footer = () => {
  return (
    <>
      <footer className="site-footer" role="contentinfo">
        <div className="shell site-footer__grid">
          <div className="site-footer__brand">
            <Link to="/" className="site-footer__logo">
              <img src={siteConfig.logo} alt={siteConfig.brandName} />
            </Link>
            <p>{siteConfig.description}</p>
            <ul className="site-footer__contact">
              <li><FiMail aria-hidden="true" /> {siteConfig.contact.email}</li>
              <li><FiMapPin aria-hidden="true" /> {siteConfig.contact.address}</li>
            </ul>
          </div>
          {footerGroups.map((group) => (
            <div className="site-footer__group" key={group.title}>
              <h3>{group.title}</h3>
              <ul>
                {group.links.map(([label, to]) => (
                  <li key={label}><Link to={to}>{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="site-footer__bottom shell">
          <span>© {new Date().getFullYear()} {siteConfig.brandName}. All rights reserved.</span>
          <div className="site-footer__payments" aria-label="Supported payment methods">
            <span>Secure payments:</span><b>VISA</b><b>Mastercard</b><b>AMEX</b><b>PayPal</b>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
